import React from 'react';
import Hero from '../components/Hero';
import WhatYouWillLearn from '../components/WhatYouWillLearn';
import AboutInstructor from '../components/AboutInstructor';
import Testimonials from '../components/Testimonials';
import Bonus from '../components/Bonus';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';

function LandingPage() {
  return (
    <div className="font-inter text-[#0d0d0d] bg-[#f2f0f0]">
      <Hero />
      <WhatYouWillLearn />
      <AboutInstructor />
      {/* <Testimonials /> */}
      <Bonus />
      <FAQ />
      <Footer />
    </div>
  );
}

export default LandingPage;